<template>
  <div class="mt-3" v-if="betKings">
    <div class="h5">
      Tippkönige
      <span class="small font-weight-light ps-2">Summe der letzten 4 Tipprunden</span>
      <fas id="friendsToggle"
           icon="user-friends"
           data-toggle="tooltip" data-placement="top"
           :title="friendsOnly ? 'klicken, um alle Trainer anzuzeigen' : 'klicken, um nur Freunde anzuzeigen'"
           class="ms-2"
           :class="{'text-sakali-primary': friendsOnly}"
           @click="friendsOnly = !friendsOnly"/>
    </div>
    <div class="card-sakali container">
      <bet-rank-entry v-for="rank in betKings" :key="rank.user.id" :live="live" :rank="rank"/>
    </div>
  </div>
</template>

<script>
import sakaliApi from '../../sakali-api'
import BetRankEntry from "./BetRankEntry";
import {mapActions, mapGetters} from 'vuex'

export default {
  props: {
    betPeriodNumber: Number,
    live: Boolean
  },
  data() {
    return {
      betKings: null,
      friendsOnly: false
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['handleErrorAction']),
    loadBetKings() {
      sakaliApi.get('/betkings/' + this.betPeriodNumber, {
        params: {
          fo: this.friendsOnly
        }
      }).then(response => {
        this.betKings = response.data
      }).catch(error => {
        this.handleErrorAction(error)
      })
    }
  },
  watch: {
    ...mapActions(['handleErrorAction']),
    betPeriodNumber() {
      this.loadBetKings();
    },
    friendsOnly() {
      this.loadBetKings();
    },
    betKings() {
      console.log("todo: tooltips")
      // $('#friendsToggle').tooltip()
    }
  },
  components: {
    BetRankEntry
  },
  mounted() {
    this.loadBetKings();
  }
}
</script>
